var app = angular.module("leonardo");

var TemplateAuditFilters = function(
  $scope,
  TemplatesAuditService,
  $controller
) {

  $controller('FiltersBaseController', { $scope: $scope });

  $scope.auditOptions = TemplatesAuditService.STATUS_OPTIONS;

  if(!$scope.filterService.hasFilter('audit')){
    $scope.filterService.setFilter('audit', TemplatesAuditService.STATUS_PENDING);
  }

  $scope.filterService.setFilter('filters', ['audit']);

  $scope.filters_options = [
    {
      group: 'hierarchy',
      name: 'By Hierarchy',
      elements: [
        {
          id: 'account_reports',
          name: 'Account',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Accounts',
          condition: $scope.authDataService.isNotStaff() && $scope.filterService.accounts.length > 1,
          options: $scope.filterService.accounts,
          conflicts: ['property_reports', 'portfolio_reports', 'group_reports', 'managed_by_reports']
        },
        {
          id: 'portfolio_reports',
          name: 'Portfolio',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Portfolios',
          condition: $scope.authDataService.isNotStaff() && $scope.filterService.portfolios.length > 1 && !$scope.only_account,
          options: $scope.filterService.portfolios,
          conflicts: ['property_reports', 'group_reports', 'managed_by_reports', 'account_reports']
        },
        {
          id: 'property_reports',
          name: 'Property',
          label: null,
          inline: false,
          type: 'property_selector',
          multiple: true,
          placeholder: 'All Properties',
          condition: $scope.authDataService.isNotStaff() && $scope.filterService.properties.length > 1 && !$scope.only_account,
          options: $scope.filterService.properties,
          conflicts: ['portfolio_reports', 'group_reports', 'managed_by_reports', 'account_reports']
        }
      ]
    },
    {
      id: 'audit',
      name: 'Audit Status',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      placeholder: 'All Status',
      condition: true,
      options: $scope.auditOptions,
      conflicts: []
    }
  ];

};

app.controller('TemplateAuditFilters', [
  '$scope',
  'TemplatesAuditService',
  '$controller',
  TemplateAuditFilters
]);
